import React, { Component } from 'react'
import ReactDOM from 'react-dom'

// Elements
// import PopupHeader from '../../elements/popupHeader'
import Icon from '../../elements/icon'
import CloseButton from '../../elements/closeButton'
// import Grid from '../../elements/grid'
// import Inline from '../../elements/inline'
import BottomBar from '../../elements/bottomBar'

// import { Icons } from '../../elements/icons'
// import styles
import './modal.scss'

// Utils
import { translation } from '../../../utils/helpers'

class Modal extends Component {

  constructor (props) {
    super(props)
    this.hideOnOuterClick = this.hideOnOuterClick.bind(this)
    this.state = {
      show: props.show,
      hideContainer: false,
      loading: false,
      reRender: false
    }
    this.onOrientationChange = this.onOrientationChange.bind(this)
  }

  onOrientationChange () {
    setTimeout(() => {
      this.setState({
        reRender: true
      })
    }, 500)
  }
  componentDidMount () {
    // Listen for orientation changes
    window.addEventListener('orientationchange', this.onOrientationChange, false)
  }

  componentWillReceiveProps (props, nextState) {
    let hideContainer = false
    if (props.hideContainer === true) {
      hideContainer = true
    }
    if (this.state.show !== props.show) {
      // on iPhone, try to scroll 1 pixel down to make the address and bottom bar minimize
      if (props.show) {
        /iPhone/i.test(navigator.userAgent) && !window.location.hash && setTimeout(() => {
          var appNode = ReactDOM.findDOMNode(document.getElementById('app'))
          // window.alert('scroll ' + appNode.scrollTop + ' ' + appNode.scrollHeight)
          appNode.scrollTop = appNode.scrollTop + 100
          appNode.scrollBy(0, 1)
          // appNode.scrollTo(appNode.scrollLeft, appNode.scrollTop + 100)
          // window.alert('scroll ' + appNode.scrollTop)
        }, 1000)
      } else {
        /iPhone/i.test(navigator.userAgent) && !window.location.hash && setTimeout(() => {
          var appNode = ReactDOM.findDOMNode(document.getElementById('app'))
          appNode.scrollBy(0, -1)
          // appNode.scrollTop = appNode.scrollTop - 100
        }, 500)
      }
    }
    this.setState({
      show: props.show,
      hideContainer: hideContainer
    })
  }
  componentWillUnmount () {
    window.removeEventListener('orientationchange', this.onOrientationChange, false)
  }
  hideOnOuterClick (event) {
    if (this.props.clickOutsideClose) {
      if (event.target.dataset.modal && this.props.onClose instanceof Function) {
        this.props.onClose(event)
      }
    }
  }

  isLoading (loading) {
    this.setState({
      loading: loading
    }, () => {
      if (loading) {
        let el = ReactDOM.findDOMNode(this.refs.content)
        el.scrollTop = 0
      }
    })
  }

  render () {
    if (!this.state.show) return null
    // Translate
    let t = translation
    if (typeof t === 'undefined') t = this.props.t
    // Class
    let contentClass = 'modal--content clearfix '
    if (this.props.overflowHidden) {
      contentClass += 'overflowhidden'
    }
    // let icon = ''
    // if (typeof this.props.icon !== 'undefined') {
    //   icon = <img src={'/images/icons/' + this.props.icon} className='header__icon' />
    // }

    let containerClass = 'modal__container'
    if (this.state.hideContainer) {
      containerClass += ' hide'
    }
    const isLoading = (this.state.loading || this.props.isLoading)
    if (isLoading) {
      containerClass += ' isLoading'
    }

    let modalIcon = ''
    if (typeof this.props.icon !== 'undefined') {
      modalIcon = <Icon icon={this.props.icon} />
      containerClass += ' show-icon'
    } else if (!this.props.hideX) {
      containerClass += ' show-icon'
    }

    const scrollOutside = (e) => {
      e.persist()
      // window.alert('scroll outside ' + e.target.classList)
      if (e.target.classList.contains('modal__wrapper') || e.target.classList.contains('modal__center')) {
        if (e.cancelBubble !== undefined) {
          e.cancelBubble = true
        }
        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation()
        }
        if (typeof e.preventDefault === 'function') {
          e.preventDefault()
        }
      }
    }

    return (
      <div className='modal__wrapper' onClick={this.hideOnOuterClick} data-modal='true' onScroll={scrollOutside} onTouchMove={scrollOutside}>
        <div className='modal__center'>
          <div className={containerClass}>
            {this.props.icon && <div className='icon-modal'>{modalIcon}</div>}
            {!this.props.hideX && <div className='hint--left modal--close' aria-label={t('2061')}><CloseButton onClick={this.props.onClose} name={this.props.closeButtonName || 'close_modal'} /></div>}
            {isLoading && (
              <div className='modal__backdrop'>
                <span className='animated-background'>
                  <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                  <span className='sr-only'>{t('13382')}...</span>
                </span>
              </div>
            )}
            <div className='modal__scroll'>
              <div className='modal--header'>
                {/* <Inline block fillChildNum={[0]} spacing={0} alignChildren='center'> */}
                <span>{this.props.header}</span>
                {/* {!this.props.hideX && <div className='hint--left modal--close' aria-label={t('2061')}><CloseButton onClick={this.props.onClose} /></div>} */}
                {/* </Inline> */}
              </div>

              <div className={contentClass} ref='content'>
                {this.props.children}
              </div>
            </div>

            {this.props.bottomBarProps !== null && (
              <div className='modal__bottomBar'>
                <BottomBar
                  cancelLabelText={!this.props.hideX && translation('1155')}
                  onCancelClick={!this.props.hideX && this.props.onClose}
                  {...this.props.bottomBarProps}
                  disabled={typeof this.props.bottomBarProps.disabled === 'function'
                    ? this.props.bottomBarProps.disabled(this.state.loading)
                    : this.props.bottomBarProps.disabled}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

}

Modal.defaultProps = {
  clickOutsideClose: true,
  isLoading: false,
  bottomBarProps: null
}

export default Modal



// WEBPACK FOOTER //
// ./src/app/shared/components/Modal/index.js